module.exports = __webpack_public_path__ + "static/img/ServiceCategory.f19bbbdf.png";